import { useMemo } from 'react'

import { generatePath, useHistory } from 'react-router-dom'

import { paths } from 'app/paths'
import { PlaybookType } from 'app/types'

import { logToAnalytics, playbookToAnalyticsProps } from 'modules'

import { useDataMutation } from './use-data-mutation'

type DuplicateType = {
    playbookId: string
    playbookTitle?: string
    playbookCreatorName?: string
}

export const useQGDuplicate = () => {
    const history = useHistory()

    const $duplicate = useDataMutation<DuplicateType, DuplicateType, Error>(
        '/c/v1/quickguidde/copy',
        'POST',
        {
            onSuccess: ({ playbookId }) => {
                history.push(
                    generatePath(paths.editQuickGuidde, {
                        playbookId
                    })
                )
            }
        }
    )

    return useMemo(
        () => ({
            duplicationIsLoading: $duplicate.isLoading,
            duplicateQG: (playbook: PlaybookType) => {
                return $duplicate.mutate({ playbookId: playbook.id }).then(data => {
                    if (!data?.playbookId) return

                    const playbookProps = playbookToAnalyticsProps(playbook)

                    logToAnalytics('duplicate-qg', {
                        ...playbookProps,
                        'new-pb-id': data.playbookId
                    })

                    logToAnalytics('duplicated-qg-created', {
                        ...playbookProps,
                        'pb-duplicated-from-id': playbook.id,
                        'pb-id': data.playbookId,
                        'pb-title': data.playbookTitle || '',
                        'pb-creator-name': data.playbookCreatorName || ''
                    })
                })
            }
        }),
        [$duplicate]
    )
}
